import React from 'react'
import blobPath from './MyMapUtils/blobPath'
import GetfacilityTypeData from './MyMapUtils/GetfacilityTypeData';
import GetManagementStatus from './MyMapUtils/GetManagementStatus';
import GetReportTypes from './MyMapUtils/GetReportTypes';
const isLogin = window.SIMPL.isLogin;

export default function SearchResultItemReport(props) {

    return (     
        <div className="sr-itemcontainer"
            id={props.data?.id}
            onMouseEnter={() => props.onEnterItem(props.data) }    
            onMouseLeave={() => props.onLeaveItem(props.data) }
            onClick={()=>  isLogin ? window.open(window.location.origin + '/Detail/Details/' + props.data.id) : null }
        >
            <a className="sr-a" rel='noopener noreferrer' href="/#">{null}</a>
            <div className="sr-item">
                <div className="sr-flex">
                    <div className="sr-flex-icon">
                        <div className="sr-flex-icondiv">
                            <img decoding="async" className="sr-item-icon" src={GetfacilityTypeData(props.data.type,"icon")}
                                aria-hidden="true" alt="" />
                        </div>
                    </div>
                    <div className="sr-flex-info">
                            <div className="sr-flex-infodiv">
                                <div className="sr-item-title">
                                    <div className="sr-item-titlevalue">
                                        <span style={{ fontWeight: 'bold' }}>{props.data.title}</span>
                                    </div>
                                </div>
                                <div className="sr-item-property"><span>住民通報[{GetReportTypes(props.data?.reportType,"name")}]</span></div>
                                <div className="sr-item-property"><span>通報日　　：{props.data?.reportDate}</span></div>
                                <div className="sr-item-property"><span>ステータス：{GetManagementStatus("reportStatus",props.data?.reportStatus,"name")}</span></div>
                                <div className="sr-item-property"><span>コメント　：{props.data?.comment}</span></div>
                            </div>
                        </div>
                    <div className="sr-flex-img">
                        <div className="sr-flex-imgdiv">
                            <a href={blobPath(props.data?.PhotoURL)} target="_blank" rel="noopener noreferrer">
                                <img decoding="async" className="sr-item-img"
                                    src={blobPath(props.data.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)}
                                    aria-hidden="true" alt="" target="_blank"
                                    onMouseEnter={(e) => props.onEnterImg(e, (props.data?.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)) }    
                                    onMouseLeave={(e) => props.onLeaveImg(e, (props.data?.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)) }
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sr-line"></div>
        </div>
    );
}